import { useRef, useState } from 'react';
import type { FormInstance } from './types';
import { FormStore } from './FormStore';

export function useForm<Values = any>(form?: FormInstance<Values>): [FormInstance<Values>] {
  const [_, forceUpdate] = useState({});
  const formRef = useRef<FormInstance<Values> | null>(null);
  const storeRef = useRef<FormStore | null>(null);

  if (!storeRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      const forceReRender = () => {
        forceUpdate({});
      };

      const store = new FormStore(forceReRender);
      formRef.current = store.getForm();
      storeRef.current = store;
    }
  }

  return [formRef.current!];
}

